import CarouselDefaultProps from "segments/desktop/core-components/carousel/default-props";
import SelectableTagsGridDefaultProps from "segments/desktop/core-components/selectable-tags-grid/default-props";
import { ALIGN_TYPES } from "constants/align-types";

export default {
  tagsAlign: ALIGN_TYPES.CENTER,
  ...CarouselDefaultProps,
  ...SelectableTagsGridDefaultProps,
};
